import { render } from "./UserAuth.vue?vue&type=template&id=32903962&scoped=true&ts=true"
import script from "./UserAuth.vue?vue&type=script&lang=ts"
export * from "./UserAuth.vue?vue&type=script&lang=ts"

import "./UserAuth.vue?vue&type=style&index=0&id=32903962&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32903962"]])

export default __exports__